export const APP_REPORT_V2 = "reportsv2";
export const APP_INTEL = "intel";
export const APP_BOLO_ALERT = "bolo-alert";
export const APP_USERS_ADMIN = "user-admin";
export const APP_CANVAS = "camera-registry";
export const APP_REGISTRY = "registry";
export const APP_MESSAGE = "message";
export const APP_CONNECT = "connect";
export const APP_FEEDBACK = "feedback";
export const APP_SETTINGS = "settings";
export const APP_PARTNER = "partner";
export const NO_APP = "no-app";
